"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerUIStatusSerialization = void 0;
const CancelledReceiptSerialization_1 = require("./CancelledReceiptSerialization");
class ChargerUIStatusSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.lost_focus_timestamp = entity.lost_focus_timestamp
            ? entity.lost_focus_timestamp.getTime() * 1000000
            : undefined;
        copy.cancelled_receipts = entity.cancelled_receipts?.map((field) => field
            ? JSON.parse(CancelledReceiptSerialization_1.CancelledReceiptSerialization.serialize(field))
            : undefined);
        copy.page_load_timestamp = entity.page_load_timestamp
            ? entity.page_load_timestamp.getTime() * 1000000
            : undefined;
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.lost_focus_timestamp = entity.lost_focus_timestamp
            ? new Date(entity.lost_focus_timestamp / 1000000)
            : undefined;
        copy.cancelled_receipts = entity.cancelled_receipts?.map((field) => field
            ? CancelledReceiptSerialization_1.CancelledReceiptSerialization.deserialize(JSON.stringify(field))
            : undefined);
        copy.page_load_timestamp = entity.page_load_timestamp
            ? new Date(entity.page_load_timestamp / 1000000)
            : undefined;
        return copy;
    }
}
exports.ChargerUIStatusSerialization = ChargerUIStatusSerialization;
